import { createRouter, createWebHashHistory } from 'vue-router';
import Home from './components/HomePage.vue';
import About from './components/AboutPage.vue';
import Welcome from './components/WelcomePage.vue';
import Story from './components/StoryPage.vue';

const subPages = [];
for (let i = 1; i <= 16; i++) {
  subPages.push({
    path: `/subpage${i}`,
    component: () => import(`./components/StorySubpage/SubPage${i}.vue`),
    name: `SubPage${i}`
  });
}



const router = createRouter({
  history: createWebHashHistory(),
    routes: [
    ...subPages,
    {
      name: 'Welcome',
      path: '/',
      component: Welcome,
      meta: {
        hideNavbar: true,
      }
    },
    {
      name: 'Home',
      path: '/home',
      component: Home
    },
    {
      name: 'About',
      path: '/about',
      component: About
    },
    {
      name: 'Story',
      path: '/story',
      component: Story,
    },
  ],
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 })
    })
  }
});

export default router;
